//  _        _      _         _
// | |  _  _| |_  _| |__ _  _| |__ _  _
// | |_| || | | || | '_ \ || | '_ \ || |
// |____\_,_|_|\_,_|_.__/\_,_|_.__/\_,_|
//
// Copyright © Lulububu Software GmbH - All Rights Reserved
// https://lulububu.de
//
// Unauthorized copying of this file, via any medium is strictly prohibited!
// Proprietary and confidential.

import I18n from 'i18next';

class Translator {
    constructor(basePath) {
        this.basePath = basePath;

        if (!basePath.endsWith('.')) {
            this.basePath += '.';
        }
    }

    t(key, options) {
        return I18n.t(this.basePath + key, options);
    }
}

export default Translator;
